import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { WhatsappComponent } from "./whatsapp.component";
import { WhatsappService } from "./whatsapp.service";
import { ReactiveFormsModule } from "@angular/forms";
import { TextMaskModule } from "angular2-text-mask";

@NgModule({
  imports: [
    MatDialogModule,
    MatButtonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    TextMaskModule,
    MatButtonModule,
    MatIconModule,
  ],
  exports: [WhatsappComponent],
  declarations: [WhatsappComponent],
  providers: [WhatsappService],
  entryComponents: [WhatsappComponent],
})
export class WhatsappModule {}
